import { createContext, useContext } from "react";

const AuthContext = createContext();

export function AuthProvider({ user, children }) {
  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
